import Vue from 'vue';
//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg';

Vue.use(VueFroala);
